import { programLabCollectionOptions } from "./programLabCheckout";

const PREVIEW_DRAW_SITE_COUNT = 5;
const DRAW_SITE_METHODS = new Set(["walk_in_test", "on_site_collection"]);

export const PREVIEW_DRAW_SITES = [
  {
    provider_network: "Bioreference",
    name: "CHINATOWN, GRAND ST",
    address: "217 Grand Street (Suite 303)",
    city: "New York",
    state: "NY",
    zip: "10013",
    hours: "Fri: 9:00AM - 7:00PM, Mon: 9:00AM - 7:00PM, Sat: 9:00AM - 7:00PM, Thu: 9:00AM - 7:00PM, Tue: 9:00AM - 7:00PM, Wed: 9:00AM - 7:00PM",
    distance_miles: 1,
  },
  {
    provider_network: "Bioreference",
    name: "CHINATOWN CENTRE ST",
    address: "139 Centre Street, Suite 524",
    city: "New York",
    state: "NY",
    zip: "10013",
    hours: "Fri: 8:00AM - 6:00PM, Mon: 8:00AM - 6:00PM, Sat: 8:00AM - 6:00PM, Sun: 8:00AM - 6:00PM, Thu: 8:00AM - 6:00PM, Tue: 8:00AM - 6:00PM, Wed: 8:00AM - 6:00PM",
    distance_miles: 1,
  },
  {
    provider_network: "Bioreference",
    name: "CHINATOWN ELIZABETH ST",
    address: "13-17 Elizabeth St (Suite 401)",
    city: "New York",
    state: "NY",
    zip: "10013",
    hours: "Fri: 9:00AM - 7:00PM, Mon: 9:00AM - 7:00PM, Sat: 9:00AM - 7:00PM, Sun: 9:00AM - 7:00PM, Thu: 9:00AM - 7:00PM, Tue: 9:00AM - 7:00PM, Wed: 9:00AM - 7:00PM",
    distance_miles: 1,
  },
  {
    provider_network: "Bioreference",
    name: "HEMO 2",
    address: "211 East 51st St",
    city: "New York",
    state: "NY",
    zip: "10022",
    hours: "Fri: 8:00AM - 7:00PM, Mon: 8:00AM - 7:00PM, Thu: 8:00AM - 7:00PM, Tue: 8:00AM - 7:00PM, Wed: 8:00AM - 7:00PM",
    distance_miles: 1,
  },
  {
    provider_network: "Bioreference",
    name: "WILLIAMSBURG",
    address: "231-A South 3rd Street (4th Floor)",
    city: "Brooklyn",
    state: "NY",
    zip: "11211",
    hours: "Fri: 8:00AM - 4:30PM, Mon: 8:00AM - 4:30PM, Sat: 9:00AM - 1:00PM, Thu: 8:00AM - 4:30PM, Tue: 8:00AM - 4:30PM, Wed: 8:00AM - 4:30PM",
  },
];

const copyPreviewDrawSites = () => PREVIEW_DRAW_SITES.map((site) => ({ ...site }));

const previewMethodAvailability = (option) => {
  const method = option?.method || option?.collection_method || "draw_site";
  const hasDrawSites = DRAW_SITE_METHODS.has(method);
  return {
    ...option,
    method,
    drawSites: hasDrawSites ? copyPreviewDrawSites() : [],
    psc_count: hasDrawSites ? PREVIEW_DRAW_SITE_COUNT : 0,
  };
};

export const previewLabAvailability = (lab) => {
  const options = programLabCollectionOptions(lab);
  if (lab?.is_combined === true) {
    return {
      is_available: true,
      is_combined: true,
      serviceable_methods: options.map(previewMethodAvailability),
    };
  }

  const method = options[0]?.method || "draw_site";
  const hasDrawSites = DRAW_SITE_METHODS.has(method);
  return {
    is_available: true,
    is_combined: false,
    drawSites: hasDrawSites ? copyPreviewDrawSites() : [],
    psc_count: hasDrawSites ? PREVIEW_DRAW_SITE_COUNT : 0,
    serviceable_methods: [],
  };
};
